import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class SomatorioHorasExtrasMOTCStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable produtos;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSomatorioHorasExtrasMOTC(filtro).then(response => {
            const empresasGloboAgrupados = _.groupBy(response.data, (d) => d.empresa);
            const empresasGlobo = Object.keys(empresasGloboAgrupados);
            const produtosAgrupadas = _.groupBy(response.data, (d) => d.produto);
            const produtos = Object.keys(produtosAgrupadas);

            let dados = [];
            _.forEach(empresasGlobo, (empresaGlobo) => {
                let dado = { nome: empresaGlobo };

                const empresasGloboProdutos = empresasGloboAgrupados[empresaGlobo];

                _.forEach(empresasGloboProdutos, (empresaGloboProduto) => {
                    dado = { ...dado, [empresaGloboProduto.produto]: empresaGloboProduto.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.produtos = produtos;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
